export default __webpack_public_path__ + "static/wxPublish-5ecd251a57b4302074c21364ddc8777d.png";